import http from '@axios'

export function createStage(data) {
  return http({
    method: 'POST',
    url: 'apartments/stage/',
    data,
  })
}

export function getStagesBySection(params) {
  return http({
    method: 'GET',
    url: `apartments/section/${params.id}/stages/`,
    params,
  })
}

export function getStagesByApartment(id) {
  return http({
    method: 'GET',
    url: `apartments/${id}/stages/`,
  })
}

export function updateStage(data) {
  return http({
    method: 'PATCH',
    url: `apartments/stage/${data.id}/`,
    data,
  })
}

export function getStageTypes() {
  return http({
    method: 'GET',
    url: 'stage-types',
  })
}

export function getStagePlannings(params) {
  return http({
    method: 'GET',
    url: 'apartments/planning-stage/',
    params,
  })
}

export function createStagePlanning(data) {
  return http({
    method: 'POST',
    url: 'apartments/planning-stage/',
    data,
  })
}

export function deleteStagePlanning(id) {
  return http({
    method: 'DELETE',
    url: `apartments/planning-stage/${id}/`,
  })
}

export function updateStagePlanning(data) {
  return http({
    method: 'PATCH',
    url: `apartments/planning-stage/${data.get('id')}/`,
    data,
  })
}

export function updateStagePlanningStages(data) {
  return http({
    method: 'POST',
    url: `apartments/planning-stage/${data.id}/update_planning/`,
    data,
  })
}
